import React, { ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import '../styles/layout.css';

interface LoggedInLayoutProps {
  children: ReactNode;
}

const LoggedInLayout: React.FC<LoggedInLayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();

  return (
    <div className="layout-container">
      {/* Sidebar / Navigation */}
      <nav className="sidebar">
        <div className="logo">
          <img src="/klinks-favicon-48.png" alt="k-links logo" />
          <span className="logo-text">k-links</span>
        </div>
        
        <ul className="nav-list">
          <li>
            <Link to="/klinks/list" className="nav-link">
              Home
            </Link>
          </li>
          <li>
            <Link to="/klinks/create" className="nav-link create-new">
              Create new
            </Link>
          </li>
        </ul>

        <div className="sidebar-footer">
          <p className="user-email">
            {user?.email}
          </p>
          <button
            onClick={logout}
            className="logout-button"
          >
            Logout
          </button>
        </div>
      </nav>

      {/* Main Content Area */}
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default LoggedInLayout;
